module.exports = __webpack_public_path__ + "logo_85-713e43b34e161bcb13bad9f30d98a6fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_85.png
// module id = 1144
// module chunks = 0 1